import config from "../config";
import { ItemService } from "../services/itemService";
import { MeetingItem } from "../models";

const quickTaskService = new ItemService(config.api.baseUrl, "/quicktask");

export const listQuickTasks = async (actor?: string, creator?: string): Promise<MeetingItem[]> => {
    // Fetch quicktasks for actor or creator
    const params: any = {};
    if (actor) params.actor = actor;
    if (creator) params.creator = creator;
    return await quickTaskService.getList(params);
};

export const getQuickTask = async (itemId: string): Promise<MeetingItem> => {
    return await quickTaskService.get(itemId);
};

export const saveQuickTask = async (item: MeetingItem): Promise<MeetingItem> => {
    return await quickTaskService.save(item);
};

export const deleteQuickTask = async (itemId: string): Promise<void> => {
    await quickTaskService.delete(itemId);
};
